import React, {Component} from "react";

import * as CommonUtils from "../utils/CommonUtils";
import * as ModalUtils from "../utils/ModalUtils";

import emptyIconSvg from "../../resources/icon/svg/common/empty_icon.svg";
import mainPageLogoNameSvg from "../../resources/icon/svg/common/logo_name.svg";
import mainPageMutanoidSvg from "../../resources/icon/svg/animation/mutanoid.svg";
import mutanoidsGameLogoSvg from "../../resources/icon/svg/common/mutanoidsgame_logo.svg";
import mutaSudokuLogoSvg from "../../resources/icon/svg/common/mutasudoku_logo.svg";
import mutaGeographyLogoSvg from "../../resources/icon/svg/common/mutageography_logo.svg";
import mutaFlyWordLogoSvg from "../../resources/icon/svg/common/mutaflyword_logo.svg";
import mutaMapeperLogoSvg from "../../resources/icon/svg/common/mutamapeper_logo.svg";
import mutaIconsLogoSvg from "../../resources/icon/svg/common/mutaicons_logo.svg";
import mutaGeography2LogoSvg from "../../resources/icon/svg/common/mutageography2_logo.svg";
import youtubeSvg from "../../resources/icon/svg/common/icon_youtube.svg";
import tiktokSvg from "../../resources/icon/svg/common/icon_tiktok.svg";
import instagramSvg from "../../resources/icon/svg/common/icon_instagram.svg";

export default class MainPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
        };
    }

    componentDidMount() {
        CommonUtils.changePageTitle(CommonUtils.getAppName())
        CommonUtils.changePageFavIcon(require('../../resources/icon/png/mutanoidsgame_logo.png'));
    }

    render() {
        return (
            <div className={'mainPageDiv'}>
                <img src={mainPageLogoNameSvg} className={'mainPageLogoName'} alt=''/>
                <img src={mainPageMutanoidSvg} className={'mainPageMutanoid'} alt=''/>

                <div className={'gameListDiv'}>
                    <div className={'gameListRowDiv'}>
                        <div className={'gameItem'}
                             onClick={ () => {
                                 let spinner = ModalUtils.showMutaSpinner();
                                 setTimeout(() => { spinner.remove(); CommonUtils.openLinkInCurrentTab('?page=mutanoidsGame') }, 1000)
                             }}>
                            <img src={mutanoidsGameLogoSvg} className={'gameItemLogo'} alt=''/>
                            <div className={'gameItemLabel'}>Mutanoids</div>
                            <div className={'gameItemLabel'} style={{marginTop:'0'}}>Game</div>
                            <div className={'gameItemTypeLabel'} style={{marginTop:'0'}}>(Android App)</div>
                        </div>
                        <div className={'gameItem'} style={{marginLeft:'2%'}}
                             onClick={ () => {
                                 let spinner = ModalUtils.showMutaSpinner();
                                 setTimeout(() => { spinner.remove(); CommonUtils.openLinkInCurrentTab('?page=mutaSudoku') }, 1000)
                             }}>
                            <img src={mutaSudokuLogoSvg} className={'gameItemLogo'} alt=''/>
                            <div className={'gameItemLabel'}>Muta</div>
                            <div className={'gameItemLabel'} style={{marginTop:'0'}}>Sudoku</div>
                            <div className={'gameItemTypeLabel'} style={{marginTop:'0'}}>(Android App)</div>
                        </div>
                        <div className={'gameItem'} style={{marginLeft:'2%'}}
                             onClick={ () => {
                                 let spinner = ModalUtils.showMutaSpinner();
                                 setTimeout(() => { spinner.remove(); CommonUtils.openLinkInCurrentTab('?page=mutaGeography') }, 1000)
                             }}>
                            <img src={mutaGeographyLogoSvg} className={'gameItemLogo'} alt=''/>
                            <div className={'gameItemLabel'}>Muta</div>
                            <div className={'gameItemLabel'} style={{marginTop:'0'}}>Geography</div>
                            <div className={'gameItemTypeLabel'} style={{marginTop:'0'}}>(Android App)</div>
                        </div>
                        <div className={'gameItem'} style={{marginLeft:'2%'}}
                             onClick={ () => {
                                 let spinner = ModalUtils.showMutaSpinner();
                                 setTimeout(() => { spinner.remove(); CommonUtils.openLinkInCurrentTab('?page=mutaFlyWord') }, 1000)
                             }}>
                            <img src={mutaFlyWordLogoSvg} className={'gameItemLogo'} alt=''/>
                            <div className={'gameItemLabel'}>Muta</div>
                            <div className={'gameItemLabel'} style={{marginTop:'0'}}>FlyWord</div>
                            <div className={'gameItemTypeLabel'} style={{marginTop:'0'}}>(Android App)</div>
                        </div>
                    </div>
                    <div style={{marginTop:'2%'}} className={'gameListRowDiv'}>
                        <div className={'gameItem'}
                             onClick={ () => {
                                 let spinner = ModalUtils.showMutaSpinner();
                                 setTimeout(() => { spinner.remove(); CommonUtils.openLinkInCurrentTab('?page=mutaGeography2') }, 1000)
                             }}>
                            <img src={mutaGeography2LogoSvg} className={'gameItemLogo'} alt=''/>
                            <div className={'gameItemLabel'}>Muta</div>
                            <div className={'gameItemLabel'} style={{marginTop:'0'}}>Geography2</div>
                            <div className={'gameItemTypeLabel'} style={{marginTop:'0'}}>(Android App)</div>
                        </div>
                        <div className={'gameItem'} style={{marginLeft:'2%'}}
                             onClick={ () => {
                                 let spinner = ModalUtils.showMutaSpinner();
                                 setTimeout(() => { spinner.remove(); CommonUtils.openLinkInNewTab('/mutaMapeper') }, 1000)
                             }}>
                            <img src={mutaMapeperLogoSvg} className={'gameItemLogo'} alt=''/>
                            <div className={'gameItemLabel'}>Muta</div>
                            <div className={'gameItemLabel'} style={{marginTop:'0'}}>Mapeper</div>
                            <div className={'gameItemTypeLabel'} style={{marginTop:'0'}}>(Web App)</div>
                        </div>
                        <div className={'gameItem'} style={{marginLeft:'2%'}}
                             onClick={ () => {
                                 let spinner = ModalUtils.showMutaSpinner();
                                 setTimeout(() => { spinner.remove(); CommonUtils.openLinkInNewTab('/mutaIcons') }, 1000)
                             }}>
                            <img src={mutaIconsLogoSvg} className={'gameItemLogo'} alt=''/>
                            <div className={'gameItemLabel'}>Muta</div>
                            <div className={'gameItemLabel'} style={{marginTop:'0'}}>Icons</div>
                            <div className={'gameItemTypeLabel'} style={{marginTop:'0'}}>(Web App)</div>
                        </div>
                        <div className={'gameItem'}>
                            <img src={emptyIconSvg} className={'gameItemLogo'} alt=''/>
                            <div className={'gameItemLabel'}/>
                            <div className={'gameItemLabel'} style={{marginTop:'0'}}/>
                        </div>
                    </div>
                </div>
                <div className={'mutanoidsGameChannelsDiv noSelect'}>
                    <img className={'mutanoidsGameChannelsDivItem'} style={{marginRight:'10px'}} src={youtubeSvg} alt={''} title={'Youtube'} onClick={ () => {
                        let spinner = ModalUtils.showMutaSpinner();
                        setTimeout(() => { spinner.remove(); CommonUtils.openLinkInNewTab('https://www.youtube.com/channel/UCu3mToyT4gH1V1GLJyfl5_Q') }, 1000)
                    }}/>
                    <img className={'mutanoidsGameChannelsDivItem'} style={{marginRight:'10px'}} src={tiktokSvg} alt={''} title={'TikTok'} onClick={ () => {
                        let spinner = ModalUtils.showMutaSpinner();
                        setTimeout(() => { spinner.remove(); CommonUtils.openLinkInNewTab('https://www.tiktok.com/@mutanoidsgame') }, 1000)
                    }}/>
                    <img className={'mutanoidsGameChannelsDivItem'} src={instagramSvg} alt={''} title={'Instagram'} onClick={ () => {
                        let spinner = ModalUtils.showMutaSpinner();
                        setTimeout(() => { spinner.remove(); CommonUtils.openLinkInNewTab('https://www.instagram.com/mutanoidsgame/') }, 1000)
                    }}/>
                </div>
                {CommonUtils.getAppVersionNameDiv()}
            </div>
        )
    }
}